/**
 * Stores the data in the session storage and dispatches an event on the body
 *
 */
export function agileSuccess(data) {
    sessionStorage.setItem('agile', JSON.stringify(data));

    const myEvent = new CustomEvent('agile-success', {
        detail: data,
        bubbles: true,
        cancelable: true,
        composed: false,
    });

    document.body.dispatchEvent(myEvent);
}

export function agileIsKnown() {
    return sessionStorage.getItem('agile') !== null;
}

export function agileGetEmail() {
    return JSON.parse(sessionStorage.getItem('agile')).email;
}
